import React, { useState } from "react";
import styles from "./ProgrammeGridView.module.css";
import GridColumn from "./GridColumn/GridColumn";
import ActivityTooltip from "./ActivityTooltip/ActivityTooltip";
import Storage from "../Storage";

export const PROGRAMME_GRID_VIEW_HOUR_HEIGHT = 220;

function ProgrammeGridView({
  activities,
  trackData,
  typesData,
  speakersList,
  activitiesList,
}) {
  const useSessionColorAsBackground = Storage.getMenu();
  const [showActivityDetail, setShowActivityDetail] = useState(null);
  const sessions = JSON.parse(JSON.stringify(activities));
  const sessionsWithTrackData = sessions.map((session) => {
    const { tracks, types } = session;
    if (tracks) {
      const matchingTrack = trackData.find(
        (track) => track.description === tracks
      );
      session.trackData = {
        color: matchingTrack?.color || "#FFFFFF",
        textColor: matchingTrack?.textColor || "#000000",
      };
    } else {
      session.trackData = {
        color: "#FFFFFF",
        textColor: "#000000",
      };
    }
    return session;
  });
  const eventsHours = [24, 0];
  // const availableRooms = Array.from(new Set(sessions.map(session => session.room))).filter(room => Boolean(room));
  const availableRooms = Storage.getRoomsInfo()
    .sort((a, b) => a.order < b.order)
    .map((r) => r.name);
  const parentActivities = sessionsWithTrackData.filter(
    (session) => !session.idParentActivity
  );
  parentActivities.forEach((activity) => {
    const { startDateTime, endDateTime } = activity;
    const startHour = Number(startDateTime.split("T")[1].split(":")[0]);
    let endHour = Number(endDateTime.split("T")[1].split(":")[0]);
    if (!Number(endDateTime.split("T")[1].split(":")[1])) {
      endHour--;
    }
    if (eventsHours[0] >= startHour) {
      eventsHours[0] = startHour;
    }
    if (eventsHours[1] <= endHour) {
      eventsHours[1] = endHour;
    }
  });
  const toolTipPayload = {
    selectedActivity: showActivityDetail,
    activitiesList,
    speakersList,
    typesData,
    trackData,
  };
  const sessionsByRooms = [];
  availableRooms.forEach((room) => {
    const sessionsForThisRoom = parentActivities.filter(
      (session) => session.room === room
    );
    sessionsByRooms.push(sessionsForThisRoom);
  });
  const sessionsByRoomsWithData = sessionsByRooms.filter((room) => room.length);
  const availableRoomsWithData = sessionsByRoomsWithData.map(
    (room) => room[0].room
  );
  const hoursRowLabels = _getHourLabels(eventsHours);

  const handleMouseEnter = (activity) => {
    activity && setShowActivityDetail(activity);
  };

  const handleMouseLeave = (value) => {
    setShowActivityDetail(null);
  };
  return (
    <div className={styles.activityGrid} id="sessions-grid-view">
      <div>
        <div className={styles.hourHeader}></div>
        {availableRoomsWithData.map((room) => (
          <ColumnHeader title={room} key={`room_column_${room}`} />
        ))}
      </div>
      <div>
        <div className={styles.column}>
          {hoursRowLabels?.map((hour) => (
            <span className={styles.hourItem} key={`hour_item_${hour}`}>
              {hour}
            </span>
          ))}
        </div>
        {sessionsByRoomsWithData.map((room) => (
          <GridColumn
            key={`activities_column_room_${room[0]?.room}`}
            columnData={room}
            eventsHours={eventsHours}
            handleMouseEnter={handleMouseEnter}
            handleMouseLeave={handleMouseLeave}
          />
        ))}
      </div>
      {Boolean(showActivityDetail) && (
        <ActivityTooltip
          activityData={toolTipPayload}
          handleMouseLeave={handleMouseLeave}
          handleMouseEnter={handleMouseEnter}
        />
      )}
    </div>
  );
}

export default ProgrammeGridView;

function ColumnHeader({ title }) {
  return (
    <div className={styles.columnHeader}>
      <span>{title}</span>
    </div>
  );
}

function _getHourLabels(eventsHours) {
  const [start, end] = eventsHours;
  const hours = [];
  for (let i = start; i <= end; i++) {
    hours.push(`${i}:00`);
  }
  return hours;
}

function getToolTipPosition(callerPosition) {
  const { top, left, width } = callerPosition;
  return {
    x: left + width + 8,
    y: top,
  };
}
